<template>
  <div class="tax-type-modal">
    <form action="" @submit.prevent="submitUserGuideData" enctype="multipart/form-data">
      <div class="card-body">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('user_guides.name') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-input
              ref="name"
              v-model="userGuideData.name"
              type="text"
              @input="$v.userGuideData.name.$touch()"
            />
            <div v-if="$v.userGuideData.name.$error">
              <span v-if="!$v.userGuideData.name.required" class="form-group__message text-danger">{{ $tc('validation.name_required') }}</span>
              <span v-if="!$v.userGuideData.name.minLength" class="form-group__message text-danger"> {{ $tc('validation.name_min_length', $v.userGuideData.name.$params.minLength.min, { count: $v.userGuideData.name.$params.minLength.min }) }} </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('user_guides.type') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-select
                ref="type"
                v-model="userGuideData.type"
                :options="TypeOptions"
                :allow-empty="false"
                :show-labels="false"
                :tabindex="5"
                :placeholder="$t('user_guides.select_type')"
                label="name"
                track-by="name"
            />
            <div v-if="$v.userGuideData.type.$error">
              <span v-if="!$v.userGuideData.type.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label input-label">{{ $t('user_guides.status') }} <span class="text-danger"> *</span></label>
          <div class="col-sm-7">
            <base-select
                v-model="userGuideData.status"
                :options="statusOptions"
                :allow-empty="false"
                :show-labels="false"
                :tabindex="5"
                :placeholder="$t('user_guides.select_status')"
                label="name"
                track-by="name"
            />
            <div v-if="$v.userGuideData.status.$error">
              <span v-if="!$v.userGuideData.status.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label input-label">{{ $t('user_guides.document') }} <span class="text-danger"> *</span></label>
            <div class="col-sm-7">
            <input   v-if="isEdit==false" ref="file" @change="onFileChange" type="file" @input="$v.userGuideData.document.$touch()"  >
            <input  v-else ref="file" @change="onFileChange" type="file">
            <br>
            <span class="form-group__message text-danger">{{  $t('user_guides.documentSizelessthan20MB') }}</span>
            <div v-if="isEdit==false && $v.userGuideData.document.$error">
              <span v-if="!$v.userGuideData.document.required" class="form-group__message text-danger">{{ $tc('validation.required') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <base-button
          :outline="true"
          class="mr-3"
          color="theme"
          type="button"
          @click="closeUserGuideModal"
        >
          {{ $t('general.cancel') }}
        </base-button>
        <base-button
          :loading="isLoading"
          :disabled="isSubmitDisabled"
          color="theme"
          icon="save"
          type="submit"
        >
          {{ !isEdit ? $t('general.save') : $t('general.update') }}
        </base-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
const { required, minLength, between, maxLength } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      isEdit: false,
      isLoading: false,
      TypeOptions:[
        {name:'Supplier'},{name:'Anchor'},{name:'Funder'}
      ],
      statusOptions:[
        {name:'Active'},{name:'Deactive'}
      ],
      userGuideData: {
        id: null,
        name:null,
        document:null,
        type:null,
        status:null,
        name:null,
      },
      selectedFile: null
    }
  },
  computed: {
    ...mapGetters('modal', [
      'modalDataID',
      'modalData',
      'modalActive'
    ]),
    isSubmitDisabled() {
      return this.$v.$invalid
    }
  },
  validations() {
    if(!this.isEdit){
      return {
        userGuideData: {
          name: {
            required,
            minLength: minLength(3)
          },
          document: {
            required,
          },
          type: {
            required
          },
          status: {
            required
          }
        },
      }
    }else{
      return {
        userGuideData: {
          name: {
            required,
            minLength: minLength(3)
          },
          id: {
            required
          },
          type: {
            required
          },
          status: {
            required
          }
        },
      }
    }
  },
  async mounted () {
    this.$refs.name.focus = true
    if (this.modalDataID) {
      this.isEdit = true
      this.setData()
    }
  },
  methods: {
    ...mapActions('modal', [
      'closeModal',
      'resetModalData'
    ]),
    ...mapActions('userGuide', [
      'updateUserGuide',
      'addUserGuide'
    ]),
    resetFormData () {
      this.userGuideData = {
        id: null,
        document: null,
        type:null,
        status:null,
        name:null
      }
      this.$v.userGuideData.$reset()
    },
    onFileChange (e) {
        if(e.target.files[0].size >=1048576*20){
          window.toastr['error'](this.$t('user_guides.documentSizeExceed20MB'));
          //this.$refs.file.value = '';
           this.isLoading = false
        }else{
            this.isLoading = true
            this.selectedFile = e.target.files[0];
            this.userGuideData.document=e.target.files[0];
            this.isLoading = false
       }
    },
    async submitUserGuideData () {
        this.$v.userGuideData.$touch()
        if (this.$v.$invalid) {
            return true
        }
        this.isLoading = true
        let response
        let DocumentData = new FormData();
        if (!this.isEdit) {
           DocumentData.append('name',this.userGuideData.name);
            DocumentData.append('type',this.userGuideData.type.name);
            DocumentData.append('status',this.userGuideData.status.name);
            DocumentData.append('document', this.selectedFile)
            response = await this.addUserGuide(DocumentData)
        }
        if (response.data) {
          if (!this.isEdit) {
            window.toastr['success'](this.$t('user_guides.created_message'))
          } else {
            window.toastr['success'](this.$t('user_guides.updated_message'))
          }
          this.$router.go('/super-admin/user-guides')
          this.closeUserGuideModal()
          this.isLoading = false
          return true
        }
        window.toastr['error'](response.data.error)
    },
    async setData () {
      this.userGuideData = {
        id: this.modalData.id,
        name: this.modalData.name,
        type: {name: this.modalData.type},
        status: {name : this.modalData.status}
      }
    },
    closeUserGuideModal () {
        this.resetModalData()
        this.resetFormData()
        this.closeModal()
    }
  }
}
</script>
